import { z } from 'zod';

/////////////////////////////////////////
// INCOMING EMAIL SCHEMA
/////////////////////////////////////////

export const IncomingEmailSchema = z.object({
  incomingemailId: z.number().int(),
  whenReceived: z.coerce.date(),
  message: z.string(),
  site: z.string(),
  processed: z.number().int(),
  error: z.number().int(),
})

export type IncomingEmail = z.infer<typeof IncomingEmailSchema>

export default IncomingEmailSchema;
